import React, { useState } from "react";
import axios from "axios";


const useSmartTaskSchedulingTaskCategory = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getSmartTaskSchedulingTaskCategoryData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/pmis/smart_task_scheduling/task_category', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                        values: data?.data
                    })
                }
                else {
                    onFinish({
                        axiosMode: "get",
                        status: "failure"
                    })
                }
                return {
                    ...data
                }
            });
    }
    const postSmartTaskSchedulingTaskCategoryData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/pmis/smart_task_scheduling/task_category',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish({
                        axiosMode: "post",
                        status: "failure"
                    })
                } else {
                    onFinish({
                        axiosMode: "post",
                        status: "success",
                        values: responseData
                    })
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "failure"
                })
            })

    }
    const patchSmartTaskSchedulingTaskCategoryData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/pmis/smart_task_scheduling/task_category',
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: responseData
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "failure"
                    }
                )
            })
    }
    const deleteSmartTaskSchedulingTaskCategoryData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/pmis/smart_task_scheduling/task_category',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success",
                            values: responseData
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "failure"
                    }
                )
            })
    }
    return {
        smartTaskSchedulingTaskCategoryData: data,
        getSmartTaskSchedulingTaskCategoryData,
        postSmartTaskSchedulingTaskCategoryData,
        patchSmartTaskSchedulingTaskCategoryData,
        deleteSmartTaskSchedulingTaskCategoryData,
    }
}
export { useSmartTaskSchedulingTaskCategory }
